export function isSSR() {
  return typeof window == 'undefined'
}
export const isDev = import.meta.dev
export const isTest = import.meta.env.TEST
